<template lang="pug">
  .b-overlay(:style="{ zIndex }")
</template>

<script>
export default {
  name: 'BaseOverlay',
  props: {
    zIndex: {
      type: Number,
      default: 1000,
    },
  },
};
</script>

<style scoped lang="scss">
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
}
</style>
